
/**
 * Inicjuje Tooltip dla elementów wybranych przez selector
 * @param {string} selector
 * @param {object} config
 * @returns {Tooltip[]}
 */
export const initTooltips = (selector, config = {}) => {
    jQuery(selector).each((i, el) => {
        new bootstrap.Tooltip(el, config)
    });
};

/**
 * Inicjuje Tooltip dla elementów wybranych przez selector
 * @param {string} selector
 * @returns {Tooltip[]}
 */
export const hideTooltips = selector => {
    jQuery(selector).each((i, el) => {
        const tooltip = bootstrap.Tooltip.getInstance(el);
        if (tooltip) {
            tooltip.hide();
        }
    });
};

/**
 * Zwraca instancję obiektu tooltip
 * @param {HTMLElement|string} selector
 * @param {object} config
 * @returns {Tooltip}
 */
export const getTooltip = (selector, config = {}) => {
    const el = jQuery(selector)[0];
    if (el) {
        return bootstrap.Tooltip.getOrCreateInstance(el, config);
    }
}

// Inicjuje szybki tooltip
document.addEventListener('DOMContentLoaded', () => {

    // FastTooltip™
    initTooltips('.fast-tooltip', {
        delay:  50,
    });

    // Bootstrap 5
    initTooltips('[data-bs-toggle="tooltip"]');

    // Dla kompatybilności z Bootstrap 3/4
    initTooltips('[data-toggle="tooltip"]');
});
